import createItemOperation from 'owa-service/lib/operation/createItemOperation';
import createItemRequest from 'owa-service/lib/factory/createItemRequest';
import CreateItemResponse from 'owa-service/lib/contract/CreateItemResponse';
import Message from 'owa-service/lib/contract/Message';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';

export default function createDraft(
    message: Message,
    timeFormat: string
): Promise<CreateItemResponse> {
    let request = createItemRequest({
        ClientSupportsIrm: false,
        ComposeOperation: 'newMail',
        MessageDisposition: 'SaveOnly',
        OutboundCharset: 'AutoDetect',
        PromoteEmojiContentToInlineAttachmentsCount: 0,
        Items: [message],
        UnpromotedInlineImageCount: 0,
        TimeFormat: timeFormat,
        ItemShape: itemResponseShape({
            BaseShape: 'IdOnly',
            ClientSupportsIrm: false,
            FilterHtmlContent: false,
            BodyType: 'HTML',
        }),
        ShapeName: 'MailCompose',
    });

    return createItemOperation({
        Header: getJsonRequestHeader(),
        Body: request,
    }).then(response => {
        return response.Body;
    });
}
